/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { VcdsOrg } from '../model/vcdsOrg';
// @ts-ignore
import { VcdsOrgPatchSpec } from '../model/vcdsOrgPatchSpec';
// @ts-ignore
import { VcdsOrgProperties } from '../model/vcdsOrgProperties';
// @ts-ignore
import { VcdsOrgRefreshSpec } from '../model/vcdsOrgRefreshSpec';
// @ts-ignore
import { VcdsOrgsInfoSummary } from '../model/vcdsOrgsInfoSummary';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OrgMgmtOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Delete org service on CSP
     * Delete org service on CSP
     * @param orgId Organization identifier
     * @param serviceType Service Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrgServiceOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<VcdsOrgProperties>;
    public deleteOrgServiceOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VcdsOrgProperties>>;
    public deleteOrgServiceOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VcdsOrgProperties>>;
    public deleteOrgServiceOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling deleteOrgServiceOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling deleteOrgServiceOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/csp-service-access`;
        return this.httpClient.request<VcdsOrgProperties>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Org Properties
     * Get Org Properties for all Org types
     * @param magicWord Type in this magic word for the query to work
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the org properties by this column
     * @param orgType Org Type
     * @param cspUngated Service Type ungated on CSP
     * @param orgTypeOveridden Flag to indicate if org type is overridden (default to false)
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllVcdsOrgPropertiesOperator(magicWord: string, sortByOrder: 'ASC' | 'DESC', sortBy: 'orgName' | 'orgId' | 'orgShortId' | 'orgType' | 'orgFoundTime' | 'orgTypeUpdatedTime' | 'orgPropertiesUpdatedTime' | 'orgSellersUpdatedTime', orgType?: string, cspUngated?: 'VCDR' | 'VMCFS', orgTypeOveridden?: boolean, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<VcdsOrgProperties>>;
    public getAllVcdsOrgPropertiesOperator(magicWord: string, sortByOrder: 'ASC' | 'DESC', sortBy: 'orgName' | 'orgId' | 'orgShortId' | 'orgType' | 'orgFoundTime' | 'orgTypeUpdatedTime' | 'orgPropertiesUpdatedTime' | 'orgSellersUpdatedTime', orgType?: string, cspUngated?: 'VCDR' | 'VMCFS', orgTypeOveridden?: boolean, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<VcdsOrgProperties>>>;
    public getAllVcdsOrgPropertiesOperator(magicWord: string, sortByOrder: 'ASC' | 'DESC', sortBy: 'orgName' | 'orgId' | 'orgShortId' | 'orgType' | 'orgFoundTime' | 'orgTypeUpdatedTime' | 'orgPropertiesUpdatedTime' | 'orgSellersUpdatedTime', orgType?: string, cspUngated?: 'VCDR' | 'VMCFS', orgTypeOveridden?: boolean, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<VcdsOrgProperties>>>;
    public getAllVcdsOrgPropertiesOperator(magicWord: string, sortByOrder: 'ASC' | 'DESC', sortBy: 'orgName' | 'orgId' | 'orgShortId' | 'orgType' | 'orgFoundTime' | 'orgTypeUpdatedTime' | 'orgPropertiesUpdatedTime' | 'orgSellersUpdatedTime', orgType?: string, cspUngated?: 'VCDR' | 'VMCFS', orgTypeOveridden?: boolean, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (magicWord === null || magicWord === undefined) {
            throw new Error('Required parameter magicWord was null or undefined when calling getAllVcdsOrgPropertiesOperator.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getAllVcdsOrgPropertiesOperator.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getAllVcdsOrgPropertiesOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>magicWord, 'magic-word');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgType, 'org-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cspUngated, 'csp-ungated');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgTypeOveridden, 'org-type-overidden');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/v2/properties`;
        return this.httpClient.request<Array<VcdsOrgProperties>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get org properties
     * Get the properties associated to an org
     * @param orgId Organization identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsOrgPropertiesOperator(orgId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<VcdsOrgProperties>;
    public getVcdsOrgPropertiesOperator(orgId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VcdsOrgProperties>>;
    public getVcdsOrgPropertiesOperator(orgId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VcdsOrgProperties>>;
    public getVcdsOrgPropertiesOperator(orgId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getVcdsOrgPropertiesOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/v2/properties`;
        return this.httpClient.request<VcdsOrgProperties>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get VCDS tenant orgs summary
     * Get VCDS tenant orgs summary
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsOrgsSummaryOperator(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<VcdsOrgsInfoSummary>;
    public getVcdsOrgsSummaryOperator(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VcdsOrgsInfoSummary>>;
    public getVcdsOrgsSummaryOperator(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VcdsOrgsInfoSummary>>;
    public getVcdsOrgsSummaryOperator(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/v2/summary`;
        return this.httpClient.request<VcdsOrgsInfoSummary>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all VCDS tenant orgs info from CSP
     * Get Tenant Orgs based on service-type
     * @param serviceType Service Type
     * @param orgType Org Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsTenantOrgsOperator(serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', orgType?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<VcdsOrg>>;
    public getVcdsTenantOrgsOperator(serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', orgType?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<VcdsOrg>>>;
    public getVcdsTenantOrgsOperator(serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', orgType?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<VcdsOrg>>>;
    public getVcdsTenantOrgsOperator(serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', orgType?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgType, 'org-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/v2/list`;
        return this.httpClient.request<Array<VcdsOrg>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modify data on an Org
     * Modify data on an Org
     * @param orgId Organization identifier
     * @param vcdsOrgPatchSpec Update Org info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchVcdsOrgPropertiesOperator(orgId: string, vcdsOrgPatchSpec: VcdsOrgPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<VcdsOrgProperties>;
    public patchVcdsOrgPropertiesOperator(orgId: string, vcdsOrgPatchSpec: VcdsOrgPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VcdsOrgProperties>>;
    public patchVcdsOrgPropertiesOperator(orgId: string, vcdsOrgPatchSpec: VcdsOrgPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VcdsOrgProperties>>;
    public patchVcdsOrgPropertiesOperator(orgId: string, vcdsOrgPatchSpec: VcdsOrgPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling patchVcdsOrgPropertiesOperator.');
        }
        if (vcdsOrgPatchSpec === null || vcdsOrgPatchSpec === undefined) {
            throw new Error('Required parameter vcdsOrgPatchSpec was null or undefined when calling patchVcdsOrgPropertiesOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/v2/properties`;
        return this.httpClient.request<VcdsOrgProperties>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: vcdsOrgPatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Purge org properties
     * API to delete the org properties for given Org.
     * @param orgId Organization identifier
     * @param forceDelete Flag to force delete given resource
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purgeVcdsOrgPropertiesOperator(orgId: string, forceDelete: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public purgeVcdsOrgPropertiesOperator(orgId: string, forceDelete: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public purgeVcdsOrgPropertiesOperator(orgId: string, forceDelete: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public purgeVcdsOrgPropertiesOperator(orgId: string, forceDelete: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling purgeVcdsOrgPropertiesOperator.');
        }
        if (forceDelete === null || forceDelete === undefined) {
            throw new Error('Required parameter forceDelete was null or undefined when calling purgeVcdsOrgPropertiesOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>forceDelete, 'force-delete');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/v2/properties`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Refresh VCDS Orgs
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshOrgsOperator(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public refreshOrgsOperator(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public refreshOrgsOperator(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public refreshOrgsOperator(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/refresh`;
        return this.httpClient.request<string>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Force refresh VCDS Org properties
     * Operator API to force refresh VMC properties, Org properties and Sellers
     * @param orgId Organization identifier
     * @param vcdsOrgRefreshSpec Refresh org properties
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshVcdsOrgPropertiesOperator(orgId: string, vcdsOrgRefreshSpec: VcdsOrgRefreshSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<VcdsOrgProperties>;
    public refreshVcdsOrgPropertiesOperator(orgId: string, vcdsOrgRefreshSpec: VcdsOrgRefreshSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VcdsOrgProperties>>;
    public refreshVcdsOrgPropertiesOperator(orgId: string, vcdsOrgRefreshSpec: VcdsOrgRefreshSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VcdsOrgProperties>>;
    public refreshVcdsOrgPropertiesOperator(orgId: string, vcdsOrgRefreshSpec: VcdsOrgRefreshSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling refreshVcdsOrgPropertiesOperator.');
        }
        if (vcdsOrgRefreshSpec === null || vcdsOrgRefreshSpec === undefined) {
            throw new Error('Required parameter vcdsOrgRefreshSpec was null or undefined when calling refreshVcdsOrgPropertiesOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/v2/refresh`;
        return this.httpClient.request<VcdsOrgProperties>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: vcdsOrgRefreshSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * UnGate org service on CSP
     * UnGate org service on CSP
     * @param orgId Organization identifier
     * @param serviceType Service Type
     * @param forceUngate Flag to force ungate the given service type when the org is not initialised on VMC
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unGateOrgServiceOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', forceUngate: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<VcdsOrgProperties>;
    public unGateOrgServiceOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', forceUngate: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VcdsOrgProperties>>;
    public unGateOrgServiceOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', forceUngate: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VcdsOrgProperties>>;
    public unGateOrgServiceOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', forceUngate: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling unGateOrgServiceOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling unGateOrgServiceOperator.');
        }
        if (forceUngate === null || forceUngate === undefined) {
            throw new Error('Required parameter forceUngate was null or undefined when calling unGateOrgServiceOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>forceUngate, 'force-ungate');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/orgs/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/csp-service-access`;
        return this.httpClient.request<VcdsOrgProperties>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
